export const containerStyle = {
  display: "flex",
  alignItems: "center",
};

export const linkStyle = {
  textDecoration: "none",
  color: "black",
};
